import { useNavigate } from 'react-router';
import { classNames } from '../../../utils/common';
import PropTypes from 'prop-types';
import useAuthContext from '../../../hooks/useAuthContext';
import { useDisclosure } from '@chakra-ui/react';
import ConfirmDialog from '../../Common/ConfirmDialog';
import AdminButtonBG from '../../../assets/images/AdminButtonBG.webp';

const ItemSidebar = ({ path, title, icon, active }) => {
  const navigate = useNavigate();
  const { logout,  } = useAuthContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div
      className={classNames(
        'flex justify-start items-center gap-2 px-5 p-2 rounded-full w-full truncate cursor-pointer hover:shadow-lg',
        active
          ? 'bg-green-secondary text-white'
          : 'bg-transparent text-primary active:text-primary/80',
      )}
      style={
        active
          ? {
              backgroundImage: `url(${AdminButtonBG})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }
          : undefined
      }
      onClick={() => (path === 'logout' ? onOpen() : navigate(path))}
    >
      {icon}
      <span>{title}</span>
      { path === 'logout' && (
        <ConfirmDialog
          title='Cerrar sesion'
          message='¿Estas seguro de cerrar sesion?'
          primaryButtonText='Cerrar sesion'
          isOpen={isOpen}
          onClose={onClose}
          onConfirm={() => {
            logout();
            onClose();
          }}
          colorScheme='bubbleGum'
        />
      )}
    </div>
  );
};

ItemSidebar.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  active: PropTypes.bool.isRequired,
};

export default ItemSidebar;
